var map = {
	"./三疣梭子蟹.jpg": 79744,
	"./伊勢龍蝦.jpg": 29957,
	"./吳郭魚.jpg": 88446,
	"./塔斯馬尼亞帝王蟹.jpg": 54186,
	"./墨魚.jpg": 41130,
	"./大王烏賊.jpg": 88985,
	"./大藍閃蝶.jpg": 32222,
	"./大鍬形蟲.jpg": 23046,
	"./大雀鱔.jpg": 32418,
	"./大龍蝦.jpg": 64872,
	"./安康魚.jpg": 48036,
	"./岩雷鳥.jpg": 67045,
	"./微光魚.jpg": 91374,
	"./扁鱈.jpg": 98673,
	"./旗魚.jpg": 23366,
	"./日本獨角仙.jpg": 85903,
	"./松葉蟹.jpg": 20094,
	"./松鼠.jpg": 647,
	"./柳葉魚.jpg": 43706,
	"./極光魚.jpg": 30426,
	"./比目魚.jpg": 23659,
	"./毛蟹.jpg": 40125,
	"./沙丁魚.jpg": 29926,
	"./泰國蝦.jpg": 11504,
	"./淡菜.jpg": 27642,
	"./游隼.jpg": 5688,
	"./湄公河巨鯰.jpg": 11959,
	"./烏鱧.jpg": 96085,
	"./熊.jpg": 53139,
	"./牡蠣.jpg": 74809,
	"./猴子.jpg": 16789,
	"./珠星三塊魚.jpg": 97874,
	"./球馬陸.jpg": 87672,
	"./發光魚.jpg": 58830,
	"./白星笛鯛.jpg": 66627,
	"./白色狐狸.jpg": 89537,
	"./白色白鼬.jpg": 25185,
	"./皇帶魚.jpg": 7695,
	"./竹筴魚.jpg": 61255,
	"./紋白蝶.jpg": 84357,
	"./老鷹.jpg": 78235,
	"./花鱸.jpg": 76523,
	"./茶色白鼬.jpg": 22013,
	"./草蝦.jpg": 31330,
	"./藍蟹.jpg": 3815,
	"./虱目魚.jpg": 91686,
	"./螃蟹.jpg": 86724,
	"./螯蝦.jpg": 21961,
	"./貓頭鷹.jpg": 677,
	"./赤貝.jpg": 83262,
	"./軟絲.jpg": 40178,
	"./透抽.jpg": 10077,
	"./長戢獨角仙.jpg": 66836,
	"./雪花鴨嘴燕魟.jpg": 22830,
	"./青鳥.jpg": 9584,
	"./鬚赤蝦.jpg": 42179,
	"./鬼頭刀.jpg": 20430,
	"./魷魚.jpg": 4340,
	"./鮑魚.jpg": 49944,
	"./鮪魚.jpg": 15314,
	"./鮭魚.jpg": 77538,
	"./鯛魚.jpg": 91154,
	"./鯡魚.jpg": 78679,
	"./鯰魚.jpg": 2017,
	"./鰻魚.jpg": 83654,
	"./鱈魚.jpg": 43434,
	"./鳳蝶.jpg": 19522,
	"./麻雀.jpg": 30736,
	"./黃帶魚.jpg": 93251,
	"./黃色狐狸.jpg": 63056,
	"./黃鱸.jpg": 56072,
	"./龍膽石斑.jpg": 8310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36500;